module.exports = __webpack_public_path__ + "static/img/kf_cloud_00004.87be649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00004.jpg
// module id = 175
// module chunks = 1